module.exports = __webpack_public_path__ + "static/media/hand-holding-magic.0768dbe8.svg";